import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** 클래스 이름 결합기. clsx로 평탄화하고 tailwind-merge로 충돌 클래스를 정리한다. */
export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}

/**
 * 식별용 표시 단축 — UUID 등 긴 식별자를 앞 8자리로 줄인다.
 * 화면에 "보여주기만" 하는 식별자에 쓴다(저장 PK/FK·URL·API 키에는 쓰지 말 것).
 */
export function shortId(id?: string | null): string {
    if (!id) return ''
    return id.length > 12 ? id.slice(0, 8) : id
}
